import React from 'react'
import { Section, HighlightedElement } from './utils'

export default function ConfluenceGuide({ className, style }) {
  return (
    <section className={className} style={style}>
      <p className="background-shade-50 bold margin-bottom-medium padding-horizontal-small padding-vertical-small radius-normal shade-05">
        Under the paid plan, your import is manually handled by an Account
        Manager.
        <br />
        <span
          className="pointer purple purple-dark-on-hover"
          onClick={() => {
            window.Intercom
              ? window.Intercom('show')
              : window.open('mailto:contact@slite.com')
          }}
        >
          Click here to get in touch.
        </span>
      </p>
      <p>
        You can export your content from Confluence into Slite one doc at a time
        or all at once, here's how:
      </p>
      <br />

      <Section>What you need to know</Section>
      <ul style={{ listStyle: 'inherit', paddingLeft: 15 }}>
        <li>
          Although we support importing content from Confluence, the end result
          might be different from what you have in Confluence because of the
          different set of features we offer.
        </li>
        <li>
          Sadly, your images will not be saved. You can drag and drop them back
          in separately from the{' '}
          <HighlightedElement>attachments</HighlightedElement> folder. We
          apologize for this inconvenience!
        </li>
      </ul>
      <br />

      <Section>Exporting individual Confluence docs into Slite</Section>
      <ol style={{ paddingLeft: 15 }}>
        <li>
          Go to the page you want to export, select the '...' button in the top
          right and then choose{' '}
          <HighlightedElement>Export to Word</HighlightedElement>.
        </li>
        <li>
          In Slite, import the doc files via the{' '}
          <HighlightedElement>Import</HighlightedElement> content menu{' '}
          <span role="img" aria-label="boom">
            💥
          </span>
        </li>
      </ol>
      <br />
      <h3 className="font-size-large margin-bottom-small shade-10">
        Exporting Confluence docs in bulk into Slite
      </h3>
      <ol style={{ paddingLeft: 15 }}>
        <li>
          Go to <HighlightedElement>Space Settings</HighlightedElement> for the
          space you're looking to export and select the{' '}
          <HighlightedElement>Content tools</HighlightedElement> section.
        </li>
        <li>
          Click on the <HighlightedElement>Export</HighlightedElement> tab, and
          select <HighlightedElement>HTML</HighlightedElement>, then hit{' '}
          <HighlightedElement>Next</HighlightedElement>, and{' '}
          <HighlightedElement>Export</HighlightedElement>. <br />
          Choose <HighlightedElement>Normal Export </HighlightedElement> unless
          you want to choose specific pages to export.
        </li>
        <li>
          Export as <HighlightedElement>html</HighlightedElement>.
        </li>
        <li>
          In Slite, import the html files via the{' '}
          <HighlightedElement>Import</HighlightedElement> content menu
          <span role="img" aria-label="boom">
            💥
          </span>
        </li>
      </ol>
    </section>
  )
}
